import React from 'react';
import navLinks from '../../api/NavLinks';
import {Link} from 'react-router-dom';
import {
    Collapse,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Nav,
    Navbar,
    NavbarToggler,
    NavItem,
    NavLink,
    UncontrolledDropdown
} from 'reactstrap'


class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false, visible: false, loader: true
        }
        this.toggle = this.toggle.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
    }

    toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    handleClick(event) {
        var elems = document.querySelectorAll('.childsubmenu');
        [].forEach.call(elems, function (el) {
            el.classList.remove('show');
        });
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll() {

        var scrollTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
        if (scrollTop > 100) {
            this.setState({
                visible: true
            });
        } else {
            this.setState({
                visible: false
            });
        }

    }

    render() {
        const {visible} = this.state;
        // console.log('this.context.router.route.location.pathname', this.context);
        // console.log('this.props.to', this.props.to);
        if (this.state.loader === true) {
            setTimeout(function () {
                this.setState({loader: false});
            }.bind(this), 2000);
        }
        return (<header className="site-header" id="home">
            {(this.state.loader === false) ? <div id="header-wrap" className={`${(visible) ? 'fixed-header ' : ''}`}>
                <div className="container">
                    <div className="row">
                        {/*menu start*/}
                        <div className="col d-flex align-items-center justify-content-between">
                            <Link className="navbar-brand logo text-dark h2 mb-0 d-flex align-items-center" to="/">
                                <img src={require('../../assets/images/logo-144-144.png')} alt="nafsi.ai"
                                     style={{height: '40px', width: 'auto', marginRight: '10px'}}/>
                                Naf<span className="text-primary font-weight-bold">si.</span>
                            </Link>
                            <Navbar className="navbar-expand-lg navbar-light ml-auto">
                                <NavbarToggler onClick={this.toggle}/>
                                <Collapse isOpen={this.state.isOpen} className=" navbar-collapse" navbar>
                                    <Nav className="ml-auto" navbar>
                                        {navLinks.map((navLink, index) => ((navLink.type && navLink.type === 'subMenu') ?
                                            <UncontrolledDropdown nav inNavbar key={index}>
                                                <DropdownToggle nav caret>
                                                    {navLink.menu_title}
                                                </DropdownToggle>
                                                <DropdownMenu id={`submenu_${index}`}
                                                              className="childsubmenu">
                                                    {navLink.child_routes && navLink.child_routes.map((subNavLink, index) => ((subNavLink.type && subNavLink.type === 'childsubMenu') ?
                                                        <UncontrolledDropdown nav inNavbar
                                                                              className="dropdown-submenu"
                                                                              key={index}>
                                                            <DropdownToggle nav caret
                                                                            className="dropdown-item">
                                                                {subNavLink.menu_title}
                                                            </DropdownToggle>
                                                            <DropdownMenu id={`childsubmenu_${index}`}>
                                                                {subNavLink.child_routes && subNavLink.child_routes.map((ChildsubNavLink, i) =>
                                                                    <DropdownItem key={i} tag={Link}
                                                                                  to={ChildsubNavLink.path}
                                                                                  onClick={this.handleClick.bind(this)}>{ChildsubNavLink.menu_title}
                                                                    </DropdownItem>)}
                                                            </DropdownMenu>
                                                        </UncontrolledDropdown> : <DropdownItem key={index} tag={Link}
                                                                                                to={subNavLink.path}>{subNavLink.menu_title}
                                                        </DropdownItem>))}
                                                </DropdownMenu>
                                            </UncontrolledDropdown> : <NavItem key={index}>
                                                {navLink.fragment ? (
                                                    <NavLink href={navLink.path + '#' + navLink.fragment}
                                                             className="page-scroll"> {navLink.menu_title}</NavLink>
                                                ) : (
                                                    <NavLink tag={Link} to={navLink.path}
                                                             className="page-scroll"> {navLink.menu_title}</NavLink>
                                                )}
                                            </NavItem>))}
                                    </Nav>
                                </Collapse>
                            </Navbar>
                            <a href="https://console.nafsi.ai/" target="_blank"
                               rel="noopener noreferrer" className="btn btn-primary ml-8 d-none d-lg-block sign-up-btn"
                            >Sign Up</a>
                        </div>
                        {/*menu end*/}
                    </div>
                </div>
            </div> : <div id="ht-preloader">
                <div className="loader clear-loader">
                    <img src={require('../../assets/images/logo-144-144.png')} alt="nafsi.ai"
                         style={{width: '120px', marginBottom: '20px'}}/>
                    <span/>
                </div>
            </div>}
        </header>);
    }
}

export default Header;
